/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cover_Letters_Generate_TitleInputs */

const en_cover_letters_generate_title = /** @type {(inputs: Cover_Letters_Generate_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generate AI Cover Letter`)
};

const de_cover_letters_generate_title = /** @type {(inputs: Cover_Letters_Generate_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KI-Anschreiben generieren`)
};

const fr_cover_letters_generate_title = /** @type {(inputs: Cover_Letters_Generate_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Générer une lettre de motivation IA`)
};

const es_cover_letters_generate_title = /** @type {(inputs: Cover_Letters_Generate_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generar carta de presentación con IA`)
};

const it_cover_letters_generate_title = /** @type {(inputs: Cover_Letters_Generate_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genera lettera di presentazione con AI`)
};

const nl_cover_letters_generate_title = /** @type {(inputs: Cover_Letters_Generate_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genereer AI-motivatiebrief`)
};

const pl_cover_letters_generate_title = /** @type {(inputs: Cover_Letters_Generate_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generuj list motywacyjny z AI`)
};

const fi_cover_letters_generate_title = /** @type {(inputs: Cover_Letters_Generate_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luo tekoälysaatekirje`)
};

const da_cover_letters_generate_title = /** @type {(inputs: Cover_Letters_Generate_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generer AI-ansøgningsbrev`)
};

const sv_cover_letters_generate_title = /** @type {(inputs: Cover_Letters_Generate_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generera AI-personligt brev`)
};

/**
* | output |
* | --- |
* | "Generate AI Cover Letter" |
*
* @param {Cover_Letters_Generate_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const cover_letters_generate_title = /** @type {((inputs?: Cover_Letters_Generate_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cover_Letters_Generate_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cover_letters_generate_title(inputs)
	if (locale === "fr") return fr_cover_letters_generate_title(inputs)
	if (locale === "es") return es_cover_letters_generate_title(inputs)
	if (locale === "it") return it_cover_letters_generate_title(inputs)
	if (locale === "nl") return nl_cover_letters_generate_title(inputs)
	if (locale === "pl") return pl_cover_letters_generate_title(inputs)
	if (locale === "fi") return fi_cover_letters_generate_title(inputs)
	if (locale === "da") return da_cover_letters_generate_title(inputs)
	if (locale === "sv") return sv_cover_letters_generate_title(inputs)
	return en_cover_letters_generate_title(inputs)
});